export const productItems = ['Features', 'Pricing'];
export const researchItems = ['Overview', 'Illuminant', 'Optics', 'Sensor', 'ISP', 'QPU'];
// export const companyItems = ['About', 'News', 'Blog', 'Careers', 'Contact'];
export const companyItems = ['Careers', 'Contact'];
export const legalItems = ['Terms of Service', 'Privacy Policy'];